import { colorConstCommon } from '@fareye/configs'
export const labelColor = {
  alert: '#D32C2B',
  ...colorConstCommon
}
export const escalation: any = {
  1: '#BFBFBF',
  2: '#FE6F4B',
  3: '#D32C2B'
}
